<template>
  <div class="report__page">
    <!--<div id="printer-header">
      <img src="/static/report-topbar.png" alt="Volta Analytics" />
      <span v-if="header" class="printer-span-header">{{ header }}</span>
    </div>-->
    <div>
      <div v-if="selectedReport">
        <div>
          <div class="report_header no-print">
            <b-row>
              <b-col class="d-flex justify-content-between align-items-center p-0">
                <div class="d-flex">
                  <h3 class="m-0">{{ selectedReport.name }}</h3>
                  <div v-if="selectedReport.data.type == 'MONTHLY'" class="d-flex ml-3">
                    <label class="mt-2">Mese:</label>
                    <vue-monthly-picker
                      class="ml-3"
                      v-model="periodSelected"
                      :monthLabels="monthLabels"
                      dateFormat="MM/YYYY"
                      :clearOption="false"
                    />
                  </div>
                  <div class="d-flex align-self-center ml-3">
                    <b-btn variant="primary" @click="downloadReport()">
                      Download <font-awesome-icon icon="download" />
                    </b-btn>
                    <b-btn :disabled="isSendingReport" variant="primary" @click="openSendReportModal" class="ml-2">
                      Invia report <font-awesome-icon icon="paper-plane" />
                    </b-btn>
                    <b-btn variant="primary" @click="openDuplicateReportModal" class="ml-2">Duplicare</b-btn>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="burger-cnt">
                    <font-awesome-icon v-if="editModeStatus && !isBurgerActive" icon="bars" class="pointer mr-3" />
                    <!--<font-awesome-icon v-if="editModeStatus && isBurgerActive" icon="times" class="pointer mr-3" @click="isBurgerActive = !isBurgerActive" /> -->
                    <div v-if="editModeStatus" class="container-burger-menu p-3">
                      <div class="pointer pb-3" @click="openEditReportTitleModal()">Modifica titolo report</div>
                      <div class="pointer pb-3" @click="nuovaPaginaModal = !nuovaPaginaModal">Aggiungi pagina</div>
                      <div class="pointer pb-3" v-b-modal.modal_header>Intestazione report</div>
                      <div class="pointer pb-3" v-b-modal.modal_send_auto>Invii automatici</div>
                      <div class="pointer">
                        <DeleteConfirmButton
                          @handleDeletePage="handleReportDelete"
                          :type="'report'"
                          :loc="{ pageIndex: null }"
                        >
                          <span class="red">Elimina Report</span>
                        </DeleteConfirmButton>
                      </div>
                    </div>
                  </div>

                  <b-form-checkbox class="" @change="toggleEditMode" v-model="editMode" name="check-button" switch>
                    Impostazioni
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="isSendingReport">
            <label>Report in fase di elaborazione, verrà inviato entro pochi minuti</label>
          </div>
          <div v-if="reportHasPages">
            <div v-for="(page, pageIndex) in selectedReportPages" :key="pageIndex" class="page_container print_div">
              <div class="page_no_header no_header_print">
                <h4>{{ page.title ? page.title : "" }}</h4>
                <div class="d-flex">
                  <small>Pagina {{ pageIndex + 1 }}</small>
                  <b-button
                    v-if="editModeStatus"
                    title="Edit page title"
                    class="p-0 ml-2 mb-0 color_black"
                    @click="addPageTitle(pageIndex)"
                    variant="default"
                  >
                    <font-awesome-icon icon="font" />
                  </b-button>
                  <DeleteConfirmButton
                    v-if="editModeStatus"
                    @handleDeletePage="handlePageDelete"
                    :emitEvent="'handleDeletePage'"
                    :loc="{ pageIndex }"
                  ></DeleteConfirmButton>
                  <b-button
                    v-if="editModeStatus && pageIndex > 0"
                    title="Move page up"
                    class="p-0 ml-0 mb-0 color_black"
                    @click="movePage(pageIndex, -1)"
                    variant="default"
                  >
                    <font-awesome-icon icon="chevron-up" />
                  </b-button>
                  <b-button
                    v-if="editModeStatus && pageIndex < selectedReportPages.length - 1"
                    title="Move page down"
                    class="p-0 ml-2 mb-0 color_black"
                    @click="movePage(pageIndex, 1)"
                    variant="default"
                  >
                    <font-awesome-icon icon="chevron-down" />
                  </b-button>
                </div>
              </div>

              <b-row class="cus_row report__page-print" :class="{ disable_resize: !editModeStatus }">
                <div class="printer-header">
                  <img class="printer-img-header" src="/static/report-topbar.png" alt="Volta Analytics" />
                  <span v-if="header" class="printer-span-header"
                    >{{ header }}
                    <template v-if="maxMonthFormatted">- {{ maxMonthFormatted }}</template>
                  </span>
                </div>
                <splitpanes
                  @resize="(event) => paneSizeResize(event, pageIndex, 'firstlevel', null)"
                  class="default-theme"
                  :horizontal="getPageLayout(pageIndex)[0].cols == '12'"
                >
                  <pane
                    :size="
                      selectedReportPages[pageIndex].firstLevel
                        ? selectedReportPages[pageIndex].firstLevel[colIndex].size
                        : null
                    "
                    min-size="5"
                    v-for="(lay, colIndex) in getPageLayout(pageIndex)"
                    :key="colIndex"
                  >
                    <splitpanes
                      @resize="(event) => paneSizeResize(event, pageIndex, 'secondlevel', colIndex)"
                      :push-other-panes="false"
                      :horizontal="lay.horizontal ? false : true"
                    >
                      <pane
                        :size="
                          selectedReportPages[pageIndex].secondLevel &&
                          selectedReportPages[pageIndex].secondLevel[colIndex]
                            ? selectedReportPages[pageIndex].secondLevel[colIndex][rowIndex].size
                            : null
                        "
                        min-size="5"
                        v-for="(laychild, rowIndex) in lay.child"
                        :key="rowIndex"
                        style="background: white"
                      >
                        <!-- SELECTION BUTTONS ARE SHOWN HERE -->
                        <div
                          v-if="getSectionType(pageIndex, colIndex, rowIndex) && editModeStatus"
                          style="height: 100%; display: flex; justify-content: center; align-items: center"
                        >
                          <b-button
                            @click="selectChartType(pageIndex, colIndex, rowIndex, sectionTypes.MISURE)"
                            variant="default"
                          >
                            <img title="Misure" src="/static/icons/chart-column.png" width="16" />
                          </b-button>
                          <b-button
                            @click="selectChartType(pageIndex, colIndex, rowIndex, sectionTypes.INDICATORI)"
                            variant="default"
                          >
                            <img title="Indicatori" src="/static/icons/chart-column.png" width="16" />
                            <span style="color: black"></span>
                          </b-button>
                          <b-button
                            @click="selectChartType(pageIndex, colIndex, rowIndex, sectionTypes.TABLE)"
                            variant="default"
                          >
                            <img title="Measure Table" src="/static/icons/icon-25.png" width="16" />
                          </b-button>
                          <b-button
                            @click="selectChartType(pageIndex, colIndex, rowIndex, sectionTypes.IND_TABLE)"
                            variant="default"
                          >
                            <img title="Indicatori Table" src="/static/icons/icon-25.png" width="16" />
                          </b-button>
                          <b-button
                            @click="selectChartType(pageIndex, colIndex, rowIndex, sectionTypes.SANKEY)"
                            variant="default"
                          >
                            <img title="Sankey" src="/static/icons/sankey.png" width="16" />
                          </b-button>
                          <b-button
                            @click="handleEditorButtonClick(pageIndex, colIndex, rowIndex, sectionTypes.TEXT)"
                            variant="default"
                          >
                            <img title="Add text" src="/static/icons/icons_menulist.png" width="16" />
                          </b-button>

                          <!-- IMAGEBOX COMPONENT USED TO SHOW SELECTION BUTTON AS WELL AS SHOWING IMAGE CONTENT -->
                          <ImageBox
                            mode="selectimage"
                            :loc="{
                              pageIndex,
                              colIndex,
                              rowIndex,
                              id: selectedReport.id,
                            }"
                            :selectedReport="selectedReport"
                            :editClass="editClass"
                            :editMode="editModeStatus"
                          >
                          </ImageBox>
                        </div>
                        <!-- SELECTION BUTTONS ENDS HERE -->

                        <!-- TEXT EDITOR SECTION -->
                        <div v-if="getSectionType(pageIndex, colIndex, rowIndex, sectionTypes.TEXT)">
                          <div class="editor-container">
                            <Editor
                              :loc="{
                                pageIndex,
                                colIndex,
                                rowIndex,
                                id: selectedReport.id,
                              }"
                              :selectedReport="selectedReport"
                              :editMode="editModeStatus"
                              @updated="refresh"
                            >
                            </Editor>
                          </div>
                        </div>
                        <!-- TEXT EDITOR SECTION ENDS -->

                        <!-- IMAGE SECTION -->
                        <div v-if="getSectionType(pageIndex, colIndex, rowIndex, sectionTypes.IMAGE)" class="h-100">
                          <ImageBox
                            :mode="'image'"
                            :image="getImage(pageIndex, colIndex, rowIndex)"
                            :loc="{
                              pageIndex,
                              colIndex,
                              rowIndex,
                              id: selectedReport.id,
                            }"
                            :selectedReport="selectedReport"
                            :editMode="editModeStatus"
                          ></ImageBox>
                        </div>
                        <!-- IMAGE SECTION ENDS HERE -->

                        <!-- CHARTS SECTION START HERE (LINE,BAR,SCATTER,TABLES, SANKEY AND OTHERS) -->
                        <div
                          v-if="getSectionType(pageIndex, colIndex, rowIndex, sectionTypes.CHART)"
                          class="chart_container"
                        >
                          <div v-if="editModeStatus" class="edit_delete_container chart-container-edit">
                            <b-button
                              v-if="editModeStatus"
                              class="p-0 mr-2 pt-1"
                              @click="addbottomLabel(pageIndex, colIndex, rowIndex)"
                              variant="default"
                            >
                              <font-awesome-icon style="color: black" icon="comment-alt" />
                            </b-button>
                            <b-button
                              title="Title"
                              v-if="editModeStatus"
                              class="color_black p-0 mr-2 mb-0"
                              @click="addSectionTitle(pageIndex, colIndex, rowIndex)"
                              variant="default"
                            >
                              <font-awesome-icon icon="font" />
                            </b-button>
                            <b-button
                              title="Edit"
                              class="color_black p-0 mb-0"
                              @click="handleEdit(pageIndex, colIndex, rowIndex)"
                              variant="default"
                            >
                              <font-awesome-icon icon="edit" />
                            </b-button>
                            <DeleteConfirmButton
                              v-if="editModeStatus"
                              @handleDeletePage="handleDelete"
                              :loc="{ pageIndex, colIndex, rowIndex }"
                            ></DeleteConfirmButton>
                          </div>
                          <div
                            v-for="(chart, chIndex) in getChart(pageIndex, colIndex, rowIndex)"
                            :key="chIndex"
                            style="display: flex; flex-direction: column"
                            class="reportSize"
                          >
                            <sectionTitleAndLabel
                              mode="title"
                              v-if="chart.title"
                              :text="chart.title"
                              :centerAlign="false"
                            ></sectionTitleAndLabel>
                            <div
                              class="flex-fill"
                              :style="{
                                height: getHeightCalc(chart.title, chart.bottomLabel),
                              }"
                            >
                              <line-chart
                                v-if="chart.current == 'line'"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                                :maxMonth="periodSelected"
                              ></line-chart>
                              <line-chart
                                v-if="chart.current == 'column'"
                                type="bar"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                                :maxMonth="periodSelected"
                              ></line-chart>
                              <CarpetAmChart
                                v-if="chart.current == 'carpet'"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                              ></CarpetAmChart>
                              <PieAmChart
                                v-if="chart.current == 'pie'"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                                :maxMonth="periodSelected"
                              >
                              </PieAmChart>
                              <scatter-chart
                                v-if="chart.current == 'scatter'"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                              ></scatter-chart>
                              <RadarAmChart
                                v-if="chart.current == 'radar'"
                                :filter="chart.filter"
                                :reportMode="true"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                              ></RadarAmChart>
                              <SankeyPage
                                v-if="chart.current == sectionTypes.SANKEY"
                                :reportMode="'fixed'"
                                :sankeyParameters="chart.filter"
                                :reportProps="{ bottomLabel: chart.bottomLabel }"
                                :maxMonth="periodSelected"
                              ></SankeyPage>
                            </div>
                            <sectionTitleAndLabel
                              mode="caption"
                              v-if="chart.bottomLabel"
                              :text="chart.bottomLabel"
                              :centerAlign="true"
                            ></sectionTitleAndLabel>
                          </div>
                        </div>
                        <!-- CHARTS SECTION ENDS HERE  -->
                      </pane>
                    </splitpanes>
                  </pane>
                </splitpanes>
              </b-row>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!selectedReport" class="no_report_selection">
        <h5 v-if="!reportsList.length">Nessun report presente</h5>
      </div>

      <b-modal
        cancel-title="Annulla"
        v-model="nuovaPaginaModal"
        title="Nuova pagina"
        size="lg"
        scrollable
        @ok="updateLayoutToReport"
      >
        <h5>Seleziona un modello:</h5>
        <div class="p-2" style="display: flex; justify-content: space-start; flex-wrap: wrap">
          <div
            v-for="(layout, indexl) in layouts"
            :key="indexl"
            class="div_34"
            @click="selectLayoutType(layout)"
            :class="{ selected_layout: selectedLayout == layout.id }"
          >
            <splitpanes class="default-theme" :horizontal="layout.layout[0].cols == '12'">
              <pane v-for="(lay, colIndex) in layout.layout" :key="colIndex">
                <splitpanes :push-other-panes="false" :horizontal="lay.horizontal ? false : true">
                  <pane v-for="(laychild, rowIndex) in lay.child" :key="rowIndex" style="padding: 2px">
                    <div style="height: 100%; background: white; border: 1px solid rgb(199 199 199)"></div>
                  </pane>
                </splitpanes>
              </pane>
            </splitpanes>
          </div>
        </div>
      </b-modal>

      <!-- New report -->
      <b-modal
        cancel-title="Annulla"
        id="modal_new_report"
        :title="reportModalTitle"
        @hide="handleCancelReportForm"
        size="md"
        scrollable
        @ok="submitReportForm($event)"
        @cancel="handleCancelReportForm"
      >
        <div class="p-5">
          <b-form ref="reportForm">
            <b-form-group label="Name:*" :invalid-feedback="invalidReportNameFeedback" :state="isReportNameStateValid">
              <b-form-input v-model="newReportForm.name" type="text" placeholder="name"></b-form-input>
              <!-- :state="isReportNameStateValid" -->
            </b-form-group>
            <b-form-group
              v-if="showReportTypeField"
              label="Tipologia:*"
              :invalid-feedback="'Please select any option'"
              :state="isReportTypeStateValid"
            >
              <b-form-select
                v-model="newReportForm.type"
                :options="tipologia"
                :disabled="isReportTypeDisabled"
              ></b-form-select>
              <!-- :state="isReportTypeStateValid" -->
            </b-form-group>
          </b-form>
        </div>
      </b-modal>

      <!-- Header -->
      <b-modal
        cancel-title="Annulla"
        id="modal_header"
        title="Intestazione report"
        @hide="handleCancelReportForm"
        size="md"
        scrollable
        @ok="updateReportHeader()"
        @cancel="handleCancelReportForm"
      >
        <div class="p-5">
          <label class="form-label">Intestazione:</label>
          <input type="text" class="form-control" v-model="header" />
        </div>
      </b-modal>

      <!-- Add misure page charts to report modal -->
      <modal name="misureModal" :width="'80%'" :height="'auto'" :scrollable="true">
        <b-row>
          <b-col cols="3" style="background: #b54141">
            <div class="sidebar_report">
              <div class="report_section sidebar-menu">
                <div class="charts-menu active">
                  <div class="charts-tree">
                    <MeasuresTree :reportMode="true" v-if="buttonType == 'misure' || buttonType == 'table'" />
                    <IndicatorsTree :reportMode="true" v-if="buttonType == 'indicatori' || buttonType == 'ind_table'" />
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="9">
            <!-- Charts and IndicatorCharts now additionally recieve a reportSection prop, that holds the section currently beinng edited -->
            <Charts
              v-if="buttonType == 'misure' || buttonType == 'table'"
              :reportSection="selectedRowColumn"
              :reportMode="buttonType == 'misure' ? true : buttonType == 'table' ? 'table' : true"
              ref="markdowndetails"
            ></Charts>
            <IndicatorCharts
              v-if="buttonType == 'indicatori' || buttonType == 'ind_table'"
              :reportSection="selectedRowColumn"
              :reportMode="
                buttonType == 'indicatori' ? true : buttonType == 'table' || buttonType == 'ind_table' ? 'table' : true
              "
              ref="markdowndetails"
            ></IndicatorCharts>
            <div class="w-100 p-2">
              <b-button
                variant="primary"
                size="sm"
                class="float-right ml-3"
                @click="addToReport(sectionTypes.CHART)"
                v-if="isAddMode"
              >
                Add to Report
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                class="float-right ml-3"
                @click="updateChartToReport()"
                v-if="!isAddMode"
              >
                Update to Report
              </b-button>

              <b-button variant="primary" size="sm" class="float-right" @click="closeMisureModal"> Annulla </b-button>
            </div>
          </b-col>
        </b-row>
      </modal>

      <!-- Add Indicatori charts to page modal -->
      <b-modal
        v-model="modalShow"
        hide-header
        size="xl"
        :body-class="'choose_chartmodal'"
        scrollable
        :header-bg-variant="'light'"
      >
        <b-row>
          <b-col cols="3" style="background: #b54141">
            <div class="sidebar_report">
              <div class="report_section sidebar-menu">
                <div class="charts-menu active">
                  <div class="charts-tree">
                    <!-- <MeasuresTree v-if="buttonType == 'misure' || buttonType == 'table'" /> -->
                    <IndicatorsTree :reportMode="true" v-if="buttonType == 'indicatori' || buttonType == 'table'" />
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="9">
            <!-- <Charts v-if="buttonType == 'misure' || buttonType == 'table' "  :reportMode="buttonType == 'misure' ? true : buttonType == 'table' ? 'table' : true "   ref="markdowndetails"></Charts> -->
            <IndicatorCharts
              v-if="buttonType == 'indicatori' || buttonType == 'table'"
              :reportMode="buttonType == 'misure' ? true : buttonType == 'table' ? 'table' : true"
              ref="markdowndetails"
            ></IndicatorCharts>
          </b-col>
        </b-row>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right ml-3"
              @click="addToReport(sectionTypes.CHART)"
              v-if="isAddMode"
            >
              Add to Report
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="float-right ml-3"
              @click="updateChartToReport()"
              v-if="!isAddMode"
            >
              Update to Report
            </b-button>

            <b-button variant="primary" size="sm" class="float-right" @click="modalShow = !modalShow">
              Annulla
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        v-model="sankeyModal"
        hide-header
        size="xl"
        :body-class="'choose_chartmodal'"
        scrollable
        :header-bg-variant="'light'"
      >
        <SankeyPage ref="sankeydowndetails" :reportMode="'editable'" :sankeyParameters="sankeyParametersForEditMode">
        </SankeyPage>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right ml-3"
              @click="addToReport(sectionTypes.SANKEY)"
              v-if="isAddMode"
            >
              Add to Report
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="float-right ml-3"
              @click="updateSankeyChartToReport()"
              v-if="!isAddMode"
            >
              Update to Report
            </b-button>

            <b-button variant="primary" size="sm" class="float-right" @click="sankeyModal = !sankeyModal">
              Annulla
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        cancel-title="Annulla"
        v-model="addTitleModal"
        hide-header
        :body-class="'choose_chartmodal'"
        scrollable
        :header-bg-variant="'light'"
        @ok="addTitleToReportPageOrSection"
      >
        <div class="p-4">
          <h3>Titolo scheda</h3>
          <b-form ref="titleForm" class="my-5">
            <b-form-group>
              <b-form-input v-model="titleNameForPageAndBlock" type="text" required></b-form-input>
            </b-form-group>
          </b-form>
        </div>
      </b-modal>

      <b-modal
        cancel-title="Annulla"
        v-model="addBottomTitleModal"
        hide-header
        :body-class="'choose_chartmodal'"
        scrollable
        :header-bg-variant="'light'"
        @ok="addbottomLabelToSection"
      >
        <div class="p-4">
          <h3>Didascalia</h3>
          <b-form ref="titleForm" class="my-5">
            <b-form-group>
              <b-form-input v-model="bottomLabelForChart" type="text" required></b-form-input>
            </b-form-group>
          </b-form>
        </div>
      </b-modal>

      <SendAutoModal :id="report.id" />

      <b-modal
        cancel-title="Annulla"
        ok-title="Invia"
        id="send_report_modal"
        title="Invia report"
        scrollable
        centered
        @ok="sendReportToEmails()"
      >
        <div class="form-group has-warning">
          <label class="control-label">Inserire gli indirizzi a cui inviare il report</label>
          <textarea class="form-control" v-model="emailsReport"></textarea>
          <span class="has-warning mt-2">Inserire un indirizzo per riga</span>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Charts from "@/components/Charts/Page";
import IndicatorCharts from "@/components/Charts/Indicators";
import MeasuresTree from "@/components/Charts/Tree/MeasuresTree";
import IndicatorsTree from "@/components/Charts/Tree/IndicatorsTree";

import VueMonthlyPicker from "vue-monthly-picker";

import ImageBox from "./imageBox";
import LineChart from "@/components/Charts/Types/Am/Line";
import PieAmChart from "@/components/Charts/Types/Am/Pie";
import CarpetAmChart from "@/components/Charts/Types/Am/Carpet";
import RadarAmChart from "@/components/Charts/Types/Am/Radar";
import ScatterChart from "@/components/Charts/Types/Am/Scatter";
import SankeyPage from "@/components/Diagnosi/Page";
import Editor from "./editor";
import SendAutoModal from "./SendAutoModal/SendAutoModal.vue";
import DeleteConfirmButton from "./deleteConfirm";
import sectionTitleAndLabel from "./sectionTitleAndLabel.vue";
import pageLayoutsJson from "./layout.json";

import { mapGetters } from "vuex";

var moment = require("moment");

import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import debounce from "lodash/debounce";
import VueCookie from "vue-cookie";
import { resetReady, markStarted } from "@/helpers/printReady";

const sectionTypes = {
  MISURE: "misure",
  INDICATORI: "indicatori",
  TABLE: "table",
  TEXT: "text",
  CHART: "chart",
  SANKEY: "sankey",
  IMAGE: "image",
  IND_TABLE: "ind_table",
};

export default {
  name: "Reports",
  // directives: {
  //   Multipane,
  // },
  components: {
    Splitpanes,
    Pane,
    ImageBox,
    Charts,
    MeasuresTree,
    LineChart,
    PieAmChart,
    CarpetAmChart,
    RadarAmChart,
    ScatterChart,
    IndicatorsTree,
    IndicatorCharts,
    Editor,
    SankeyPage,
    DeleteConfirmButton,
    sectionTitleAndLabel,
    VueMonthlyPicker,
    SendAutoModal,
  },
  data() {
    return {
      modalShow: false,
      tipologia: [
        { text: "Libero", value: "FREE" },
        { text: "Mensile", value: "MONTHLY" },
      ],
      newReportForm: {
        name: "",
        type: "",
      },
      editClass: "",
      nuovaPaginaModal: false,
      layouts: pageLayoutsJson,
      selectedLayout: null,
      selectedRowColumn: null,
      buttonType: null,
      editorModal: false,
      sankeyModal: false,
      sectionTypes: sectionTypes,
      editMode: false,
      sankeyParametersForEditMode: undefined,
      confirmDeleteModal: false,
      isAddMode: true,
      addTitleModal: false,
      titleNameForPageAndBlock: "",
      newReportFormSubmitted: false,
      addBottomTitleModal: false,
      bottomLabelForChart: "",
      splitPaneDimensionsReport: null,
      periodSelected: null,
      isBurgerActive: false,
      report: {},
      header: null,
      maxMonthFormatted: "",
      emailsReport: "",
      isSendingReport: false,
      reportFormMode: "create",
    };
  },
  mounted() {
    document.body.classList.add("report-page");
  },
  destroyed() {
    document.body.classList.remove("report-page");
  },
  async created() {
    const reportId = this.$route.params.id;
    const month = this.$route.params.month;

    // Reset the print-readiness flag so the Puppeteer service only sees
    // `window.__VOLTA_REPORT_READY__ === true` once this report's charts have
    // all finished rendering.
    resetReady();

    if (month) {
      this.periodSelected = moment(month, "MM-yyyy");
    }

    this.$store.commit("loading");
    await this.$store.dispatch("report/listReportBuilder");
    this.$store.commit("stopLoading");

    if (reportId) {
      this.$store.commit("loading");
      try {
        await this.$store.dispatch("report/getReportBuilder", { id: reportId, month: "" });
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
      if (this.selectedReport && this.selectedReport.data && this.selectedReport.data.type) {
        if (this.selectedReport.data.type == "MONTHLY") {
          if (!this.periodSelected) {
            this.periodSelected = moment();
          }
          try {
            await this.$store.dispatch("report/getReportBuilder", {
              id: reportId,
              month: moment(this.periodSelected).format("MM-yyyy"),
            });
          } catch (e) {
            this.$notify({
              type: "error",
              text: e.message,
              title: "Errore",
            });
          }
        } else {
          try {
            await this.$store.dispatch("report/getReportBuilder", { id: reportId, month: "" });
          } catch (e) {
            this.$notify({
              type: "error",
              text: e.message,
              title: "Errore",
            });
          }
        }
      }

      this.$store.commit("stopLoading");
    } /* else {
      this.$store.dispatch("report/getReportBuilder", null);
    }*/
    if (this.selectedReport) {
      this.report = { ...this.selectedReport };
      this.header = this.report.data.header;
    }
    this.$store.dispatch("report/toggleEditMode", false);

    // Signal that report content has mounted so the Puppeteer print service can
    // settle even for reports that contain no charts (tables/text/images only).
    this.$nextTick(() => {
      markStarted();
    });
  },

  watch: {
    splitPaneDimensionsReport: {
      handler: debounce(async function Unnamed() {
        await this.updateSplitPaneResizeSilently();
      }, 1000),
      deep: false,
    },
    periodSelected() {
      this.maxMonthFormatted =
        moment(this.periodSelected).format("MMMM YYYY").charAt(0).toUpperCase() +
        moment(this.periodSelected).format("MMMM YYYY").slice(1);
      this.refresh();
    },
  },

  methods: {
    async sendReportToEmails() {
      this.isSendingReport = true;
      try {
        let emails = [];
        for (let i = 0; i < this.emailsReport.split("\n").length; i++) {
          emails.push(this.emailsReport.split("\n")[i]);
        }

        let month = null;

        if (this.selectedReport.data.type == "MONTHLY") {
          month = this.periodSelected.format("MM-yyyy");
        }

        this.$store
          .dispatch("report/sendReportToEmails", { id: this.$route.params.id, month: month, emails: emails })
          .then((response) => {
            if (response.data) {
              this.$notify({
                type: "success",
                title: "Successo",
                text: "Report inviato per email",
              });
              this.$bvModal.hide("send_report_modal");
            }
            this.isSendingReport = false;
          });
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
        this.isSendingReport = false;
      }
    },
    openSendReportModal() {
      const emails = [...this.$store.state.user.emailsReport];
      if (emails && emails.length > 0) {
        this.emailsReport = emails.join("\n");
      }

      this.$bvModal.show("send_report_modal");
    },
    downloadReport() {
      let url;
      if (this.selectedReport.data.type === "MONTHLY") {
        url = `api/v1/report-builder/${this.$route.params.id}/${this.formatMonth(
          this.periodSelected
        )}/download?token=${this.getToken()}&customer=${this.$store.state.user.databaseName}`;
      } else {
        url = `api/v1/report-builder/${this.$route.params.id}/download?token=${this.getToken()}&customer=${
          this.$store.state.user.databaseName
        }`;
      }
      this.download(url);
    },
    download(url) {
      this.$store.commit("loading");
      fetch(url, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((response) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "report.pdf";
          document.body.appendChild(a);
          this.$store.commit("stopLoading");
          a.click();
        });
    },
    getToken() {
      if (VueCookie.get("token")) {
        return VueCookie.get("token");
      }
      return this.$route.params.token;
    },
    formatMonth(month) {
      return moment(month).format("MM-yyyy");
    },
    async refresh() {
      let month = "";
      if (this.selectedReport && this.selectedReport.data && this.selectedReport.data.type == "MONTHLY") {
        month = this.formatMonth(this.periodSelected);
      }

      if (!month) {
        return;
      }

      this.$store.commit("loading");
      try {
        await this.$store.dispatch("report/getReportBuilder", { id: this.$route.params.id, month: month });
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      } finally {
        this.$store.commit("stopLoading");
      }
    },

    downloadData() {
      location.href = "text/json;charset=utf-8," + encodeURIComponent(this.selectedReport);
    },

    async updateSplitPaneResizeSilently() {
      if (this.splitPaneDimensionsReport) {
        let reportToBeUpdated = { ...this.splitPaneDimensionsReport };
        this.splitPaneDimensionsReport = null;
        await this.$store.dispatch("report/updateReportBuilder", reportToBeUpdated);
      }
    },

    paneSizeResize(event, pageIndex, levelType, colIndex) {
      let report = _.cloneDeep(this.selectedReport);
      if (levelType == "firstlevel") {
        report.data.pages[pageIndex].firstLevel = event;
      } else if (levelType == "secondlevel") {
        if (!report.data.pages[pageIndex].secondLevel) {
          report.data.pages[pageIndex].secondLevel = {};
        }
        report.data.pages[pageIndex].secondLevel[colIndex] = event;
      }
      this.splitPaneDimensionsReport = _.cloneDeep(report);
    },

    handleEditorButtonClick(pageIndex, colIndex, rowIndex, type) {
      // this.$store.dispatch('report/toggleEditMode', false);
      let section = {
        loc: { pageIndex, colIndex, rowIndex },
        sectionType: sectionTypes.TEXT,
      };

      let data = {
        pageIndex: pageIndex,
        section,
        id: this.selectedReport.id,
      };

      this.$store.dispatch("report/updateReportSectionInVuex", data);
    },

    async addToReport(type) {
      if (!type) {
        return;
      }

      this.$store.commit("loading");
      var { sectionType, ...selectedSectionIndex } = this.selectedRowColumn;
      if (type == sectionTypes.CHART) {
        var markdowns = this.$refs.markdowndetails;
        let chartType = markdowns.current;
        let filters = markdowns.filter;
        filters.enableTruncatedAverage = true;
        // filters.sources = this.$store.state.charts.lastFetchedChartParameters.sources;
        let isRolling = markdowns.$refs.lineChartRef ? markdowns.$refs.lineChartRef.isRolling : false;

        if (isRolling) {
          filters.rolling = true;
        }

        sectionType = sectionType == "ind_table" ? "table" : sectionType;

        var section = {
          current: chartType,
          filter: filters,
          loc: selectedSectionIndex,
          sectionType,
        };
        // this.modalShow = false
        this.closeMisureModal();
      } else if (type == sectionTypes.SANKEY) {
        let chartType = sectionTypes.SANKEY;
        let sMarkDowns = this.$refs.sankeydowndetails.$children.find((ele) => ele.isSankey);
        let site = this.$refs.sankeydowndetails.site;
        var section = {
          current: chartType,
          loc: selectedSectionIndex,
          sectionType,
          filter: {
            curDepth: sMarkDowns.curDepth,
            selectedVectors: sMarkDowns.selectedVectors,
            site,
            fromMonth: this.$refs.sankeydowndetails.fromMonth.format("MM-YYYY"),
            toMonth: this.$refs.sankeydowndetails.toMonth.format("MM-YYYY"),
          },
        };
        this.sankeyModal = false;
      }

      let data = {
        pageIndex: this.selectedRowColumn.pageIndex,
        section,
        id: this.selectedReport.id,
      };

      let report = _.cloneDeep(this.selectedReport);
      let pages = report.data.pages;
      let sections = pages ? pages[data.pageIndex].sections : [];
      sections.push(section);
      report.data.pages[data.pageIndex].sections = sections;
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
    },

    async updateChartToReport() {
      //retrieving section info saved in selectedRowCOlumn earlier (in 'handleEdit' function)
      let { pageIndex, rowIndex, colIndex, ...section } = this.selectedRowColumn;
      //updating section's filter based on source selection modal's updated filters
      const filter = this.$refs.markdowndetails.filter;
      filter.enableTruncatedAverage = true;

      let isRolling = this.$refs.markdowndetails.$refs.lineChartRef
        ? this.$refs.markdowndetails.$refs.lineChartRef.isRolling
        : false;
      if (isRolling) {
        filter.rolling = true;
      }

      section.filter = {
        ...section.filter,
        ...filter,
      };

      //cloning complete report from vuex store [report module]
      let report = _.cloneDeep(this.selectedReport);
      //retrieving section index for the updated section
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });
      //replacing old version of section with new updated version of section
      report.data.pages[pageIndex].sections.splice(sectionIndex, 1, section);
      //closing source selection modal
      this.closeMisureModal();

      // await this.$store.dispatch('report/updateReportInVuex', report);

      // updating report in vuex store [report module]
      await this.$store.dispatch("report/updateReportBuilder", report);

      // setTimeout(() => {
      //   this.addToReport(sectionTypes.CHART);
      // },1000)
    },

    async updateSankeyChartToReport() {
      let { pageIndex, rowIndex, colIndex, sectionType } = this.selectedRowColumn;
      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });
      report.data.pages[pageIndex].sections.splice(sectionIndex, 1);

      await this.$store.dispatch("report/updateReportInVuex", report);

      setTimeout(() => {
        this.addToReport(sectionTypes.SANKEY);
      }, 1000);
    },

    async handleAddNewReport(event) {
      event.preventDefault();
      this.newReportFormSubmitted = true;
      let { name, type } = { ...this.newReportForm };

      if (!this.isReportNameStateValid || !this.isReportTypeStateValid) {
        return;
      }

      this.$store.commit("loading");
      let report = {
        name,
        data: {
          type,
          pages: [],
        },
      };
      await this.$store.dispatch("report/addReportBuilder", report);
      this.report = { ...this.selectedReport };
      this.resetReportForm();
      this.$bvModal.hide("modal_new_report");
      this.newReportFormSubmitted = false;
      this.$store.commit("stopLoading");
    },

    async handleDuplicateReport(event) {
      event.preventDefault();
      this.newReportFormSubmitted = true;

      if (!this.isReportNameStateValid || !this.selectedReport) {
        return;
      }

      this.$store.commit("loading");
      try {
        const duplicatedReport = await this.$store.dispatch("report/duplicateReportBuilder", {
          id: this.selectedReport.id,
          name: this.newReportForm.name,
        });
        this.resetReportForm();
        this.$bvModal.hide("modal_new_report");
        this.newReportFormSubmitted = false;
        this.$router.push(`/reports/${duplicatedReport.id}`);
      } finally {
        this.$store.commit("stopLoading");
      }
    },

    submitReportForm(event) {
      if (this.reportFormMode === "rename") {
        return this.updateReportTitle(event);
      }

      if (this.reportFormMode === "duplicate") {
        return this.handleDuplicateReport(event);
      }

      return this.handleAddNewReport(event);
    },

    handleCancelReportForm(event) {
      this.resetReportForm();
    },

    resetReportForm() {
      this.newReportForm = {
        name: "",
        type: "",
      };
      this.newReportFormSubmitted = false;
      this.reportFormMode = "create";
    },

    getDuplicateReportName() {
      if (!this.selectedReport || !this.selectedReport.name) {
        return "";
      }

      return `${this.selectedReport.name} copia`;
    },

    openDuplicateReportModal() {
      if (!this.selectedReport) {
        return;
      }

      this.reportFormMode = "duplicate";
      this.newReportForm = {
        name: this.getDuplicateReportName(),
        type: this.selectedReport.data && this.selectedReport.data.type ? this.selectedReport.data.type : "",
      };
      this.newReportFormSubmitted = false;
      this.$bvModal.show("modal_new_report");
    },

    openEditReportTitleModal() {
      this.editTitle();
      this.$bvModal.show("modal_new_report");
    },

    selectLayoutType(layout) {
      this.selectedLayout = layout.id;
    },

    async updateLayoutToReport() {
      if (!this.selectedLayout) {
        return;
      }
      this.$store.commit("loading");
      let reportPages = this.reportHasPages ? [...this.selectedReport.data.pages] : [];
      let page = {
        layout: this.selectedLayout,
        sections: [],
      };

      reportPages.push(page);

      let report = _.cloneDeep(this.selectedReport);
      report.data.pages = reportPages;

      await this.$store.dispatch("report/updateReportBuilder", report);
      this.selectedLayout = undefined;
      this.$store.commit("stopLoading");
    },

    async movePage(pageIndex, step) {
      this.$store.commit("loading");
      let reportPages = this.reportHasPages ? [...this.selectedReport.data.pages] : [];
      if ((step === -1 && pageIndex === 0) || (step === 1 && pageIndex >= reportPages.length - 1)) {
        this.$store.commit("stopLoading");
        return;
      }

      reportPages.splice(pageIndex + step, 0, reportPages.splice(pageIndex, 1)[0]);

      let report = _.cloneDeep(this.selectedReport);
      report.data.pages = reportPages;

      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
    },

    selectChartType(pageIndex, colIndex, rowIndex, sectionType) {
      this.isAddMode = true;
      // this.$store.dispatch('report/toggleEditMode', false);
      this.selectedRowColumn = { colIndex, rowIndex, pageIndex, sectionType };
      this.buttonType = sectionType;
      if (
        sectionType == sectionTypes.MISURE ||
        sectionType == sectionTypes.INDICATORI ||
        sectionType == sectionTypes.TABLE ||
        sectionType == sectionTypes.IND_TABLE
      ) {
        // this.modalShow = true;
        this.$modal.show("misureModal");
      } else if (sectionType == sectionTypes.SANKEY) {
        this.sankeyModal = true;
      }
    },

    getChart(pageIndex, colIndex, rowIndex) {
      try {
        let chart = this.selectedReport.data.pages[pageIndex].sections.filter(
          (ele) =>
            (ele.sectionType == sectionTypes.MISURE ||
              ele.sectionType == sectionTypes.INDICATORI ||
              ele.sectionType == sectionTypes.TABLE ||
              ele.sectionType == sectionTypes.SANKEY) &&
            ele.loc.colIndex == colIndex &&
            rowIndex == ele.loc.rowIndex
        );
        return chart;
      } catch (error) {
        return [];
      }
    },

    getImage(pageIndex, colIndex, rowIndex) {
      try {
        let image = this.selectedReport.data.pages[pageIndex].sections.find((element) => {
          if (element.loc.colIndex == colIndex && element.loc.rowIndex == rowIndex) {
            return element;
          }
        });
        return image;
      } catch (error) {
        return false;
      }
    },

    getEditorData(pageIndex, colIndex, rowIndex, type) {
      try {
        let editor = this.selectedReport.data.pages[pageIndex].sections
          .filter((ele) => ele.sectionType == sectionTypes.TEXT)
          .find((ele) => ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex);
        if (type == "id") {
          return editor.editorId;
        }
        return text;
      } catch (error) {
        return null;
      }
    },

    getSectionType(pageIndex, colIndex, rowIndex, checkType = false) {
      try {
        let section = this.selectedReport.data.pages[pageIndex].sections.find(
          (ele) => ele.loc.colIndex == colIndex && ele.loc.rowIndex == rowIndex
        );

        if (checkType == sectionTypes.CHART) {
          if (
            section.sectionType == sectionTypes.MISURE ||
            section.sectionType == sectionTypes.INDICATORI ||
            section.sectionType == sectionTypes.TABLE ||
            section.sectionType == sectionTypes.SANKEY ||
            section.sectionType == sectionTypes.IND_TABLE
          )
            return true;

          return false;
        } else if (checkType == sectionTypes.TEXT) {
          return section.sectionType == sectionTypes.TEXT;
        } else if (checkType == sectionTypes.IMAGE) {
          return section.sectionType == sectionTypes.IMAGE;
        } else if (!checkType && !section) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },

    getPageLayout(pageIndex) {
      if (this.reportHasPages) {
        let layout = this.layouts.find((e) => e.id == this.selectedReport.data.pages[pageIndex].layout);
        return layout.layout;
      }
      return [];
    },

    printReport() {
      window.print();
    },

    async handleDelete({ pageIndex, colIndex, rowIndex }) {
      this.$store.commit("loading");
      let data = {
        pageIndex,
        colIndex,
        rowIndex,
        id: this.selectedReport.id,
      };

      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex;
      });
      report.data.pages[data.pageIndex].sections.splice(sectionIndex, 1);

      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
    },

    async handleEdit(pageIndex, colIndex, rowIndex) {
      //isAddMode is set to false to indicate this is not a new report
      this.isAddMode = false;
      //retrieving section based on pageIndex, rowIndex & colIndex
      let section = this.selectedReport.data.pages[pageIndex].sections.find(
        (ele) => ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex
      );
      //setting required section info in selectedRowColumn
      this.selectedRowColumn = { colIndex, rowIndex, pageIndex, ...section };
      //if section's type is not SANKEY
      if (section.sectionType != sectionTypes.SANKEY) {
        //load measure types in vuex store (charts module) if not already present
        if (!this.$store.getters["charts/measureTypes"].length === 0) {
          await this.$store.dispatch("charts/loadmeasuretypes");
        }

        //setting button type
        //if section type is table and mode is "INDICATORS", setting button type tp IND_TABLE
        if (section.filter.mode === "INDICATORS" && section.sectionType === sectionTypes.TABLE)
          this.buttonType = sectionTypes.IND_TABLE;
        else this.buttonType = section.sectionType;

        //unknown reasons for this condition
        if (
          section.sectionType == sectionTypes.MISURE ||
          section.sectionType == sectionTypes.INDICATORI ||
          section.sectionType == sectionTypes.TABLE ||
          section.sectionType == sectionTypes.IND_TABLE
        ) {
          //setting source selection modal to visible
          this.$modal.show("misureModal");
        }

        //if type is SANKEY
      } else if (sectionType == sectionTypes.SANKEY) {
        this.sankeyParametersForEditMode = section.filter;
        this.sankeyModal = true;
      }
    },

    async handlePageDelete(pageIndex) {
      this.$store.commit("loading");
      let report = _.cloneDeep(this.selectedReport);
      report.data.pages.splice(pageIndex.pageIndex, 1);
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
    },

    editTitle() {
      let report = _.cloneDeep(this.selectedReport);
      this.reportFormMode = "rename";
      this.newReportForm = {
        name: report.name,
        type: report.data && report.data.type ? report.data.type : "",
      };
      this.newReportFormSubmitted = false;
    },

    async updateReportHeader() {
      let report = _.cloneDeep(this.selectedReport);
      report.data.header = this.header;
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.report = _.cloneDeep(this.selectedReport);
      this.$bvModal.hide("modal_header");
      this.$store.commit("stopLoading");
    },

    async updateReportTitle(event) {
      event.preventDefault();
      this.newReportFormSubmitted = true;

      if (!this.isReportNameStateValid) {
        return;
      }

      this.$store.commit("loading");
      let { name, ...rest } = { ...this.newReportForm };
      let report = _.cloneDeep(this.selectedReport);
      report.name = name;
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.resetReportForm();
      this.$bvModal.hide("modal_new_report");
      this.$store.commit("stopLoading");
      this.newReportFormSubmitted = false;
    },

    toggleEditMode() {
      if (this.editModeStatus) {
        this.editClass = "falseBoxImage";
      } else {
        this.editClass = "falseBoxImage";
      }
      this.$store.dispatch("report/toggleEditMode", this.editMode);
    },

    handleDeleteConfirm() {},

    async handleReportDelete() {
      this.$store.commit("loading");
      await this.$store.dispatch("report/deleteReportBuilder", this.selectedReport.id);
      this.$store.commit("stopLoading");
      this.$router.push("/reports");
    },

    closeMisureModal() {
      this.$modal.hide("misureModal");
    },

    addSectionTitle(pageIndex, colIndex, rowIndex) {
      this.addTitleModal = true;
      this.selectedRowColumn = { colIndex, rowIndex, pageIndex, titleType: "section" };
      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });

      let sectionTitle = report.data.pages[pageIndex].sections[sectionIndex].title
        ? report.data.pages[pageIndex].sections[sectionIndex].title
        : "";
      this.titleNameForPageAndBlock = sectionTitle;
    },

    addPageTitle(pageIndex) {
      this.addTitleModal = true;
      this.selectedRowColumn = { pageIndex, titleType: "page" };

      let report = _.cloneDeep(this.selectedReport);

      let pageTitle = report.data.pages[pageIndex].title ? report.data.pages[pageIndex].title : "";
      this.titleNameForPageAndBlock = pageTitle;
    },

    async addTitleToReportPageOrSection() {
      this.$store.commit("loading");

      let { pageIndex, rowIndex, colIndex, titleType } = this.selectedRowColumn;
      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });
      if (titleType == "section") {
        report.data.pages[pageIndex].sections[sectionIndex].title = this.titleNameForPageAndBlock;
      } else if (titleType == "page") {
        report.data.pages[pageIndex].title = this.titleNameForPageAndBlock;
      }
      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
      this.addTitleModal = false;
    },

    addbottomLabel(pageIndex, colIndex, rowIndex) {
      // hello
      this.addBottomTitleModal = true;
      this.selectedRowColumn = { colIndex, rowIndex, pageIndex, titleType: "section" };

      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });

      let bottomLabel = report.data.pages[pageIndex].sections[sectionIndex].bottomLabel
        ? report.data.pages[pageIndex].sections[sectionIndex].bottomLabel
        : "";
      this.bottomLabelForChart = bottomLabel;
    },

    async addbottomLabelToSection() {
      this.$store.commit("loading");

      let { pageIndex, rowIndex, colIndex, titleType } = this.selectedRowColumn;
      let report = _.cloneDeep(this.selectedReport);
      let sectionIndex = report.data.pages[pageIndex].sections.findIndex((ele) => {
        return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex;
      });
      report.data.pages[pageIndex].sections[sectionIndex].bottomLabel = this.bottomLabelForChart;

      await this.$store.dispatch("report/updateReportBuilder", report);
      this.$store.commit("stopLoading");
      this.addTitleModal = false;
    },

    getHeightCalc(title, bottomLabel) {
      if (title && bottomLabel) {
        return "calc(100% - 48px)";
      } else if ((title && !bottomLabel) || (!title && bottomLabel)) {
        return "calc(100% - 24px)";
      } else {
        return "calc(100% - 0px)";
      }
    },
  },

  computed: {
    monthLabels() {
      return "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_");
    },
    invalidReportNameFeedback() {
      if (!this.newReportForm.name.length) {
        return "Please enter Report name";
      }
    },

    reportModalTitle() {
      if (this.reportFormMode === "rename") {
        return "Modifica titolo Report";
      }

      if (this.reportFormMode === "duplicate") {
        return "Duplica report";
      }

      return "Nuovo report";
    },

    showReportTypeField() {
      return this.reportFormMode === "create";
    },

    isReportTypeDisabled() {
      return this.reportFormMode !== "create";
    },

    isReportNameStateValid() {
      if (!this.newReportFormSubmitted) {
        return null;
      }

      if (this.newReportForm.name.length < 1 || !this.newReportForm.name.length) {
        return false;
      }
      return true;
    },

    isReportTypeStateValid() {
      if (this.reportFormMode !== "create") {
        return true;
      }
      if (!this.newReportFormSubmitted) {
        return null;
      }
      if (this.newReportForm.type.length < 1) {
        return false;
      }
      return true;
    },

    reportHasPages() {
      let report = this.selectedReport;
      if (report.data && report.data.pages && report.data.pages.length) {
        return true;
      } else {
        return false;
      }
    },

    selectedReportPages() {
      if (this.reportHasPages) {
        return this.selectedReport.data.pages;
      } else {
        return [];
      }
    },

    ...mapGetters({
      reportsList: "report/getReportsList",
      editModeGetter: "report/editMode",
      selectedReport: "report/selectedReport",
      getAdminStatus: "getAdminStatus",
    }),

    editModeStatus() {
      this.editMode = this.editModeGetter;
      return this.editModeGetter;
    },
  },
};
</script>

<style scoped>
.report__page > div {
  margin-top: 2.5rem;
}
.date-report {
  width: auto;
}

#date-picker {
  font-size: 13px;
}

@media print {
  .printer-span-header {
    position: absolute;
    right: 40px;
    top: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
  }
}
.burger-menu {
  width: 32px;
}
.container-burger-menu {
  position: absolute;
  top: 25px;
  right: 95px;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 1000;
  background: #fff;
  box-shadow: rgb(0 0 0 / 10%) 10px 10px 20px;
}
.container-burger-menu {
  display: none;
}
.burger-cnt:hover .container-burger-menu {
  display: block;
}
.red {
  color: red;
}
.pointer {
  cursor: pointer;
}

.charts_container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.chart_div {
  width: 40%;
  border: 1px solid grey;
  border-radius: 4px;
  background: white;
  box-shadow: 6px 0px 10px #aaaaaa;
  padding: 5px;
  margin-bottom: 10px;
}

.resizable-content {
  height: 100%;
  width: 100%;
}
.sidebar .badge {
  position: absolute;
  top: 10px;
  right: 50px;
  color: yellow;
}
.sidebar .sidebar-menu li.menu-title {
  border-bottom: 2px solid;
  background: #2d363f;
  padding: 10px;
}
.sidebar .sidebar-menu li select {
  width: 100%;
  height: 40px;
}
.sidebar .sidebar-menu li.menu-title a {
  color: #fff;
  font-weight: bold;
}
.sidebar .sidebar-menu li.active ul {
  display: block;
}
.sidebar .sidebar-menu > li > .row > a svg,
.sidebar .sidebar-menu > li > a svg {
  margin-right: 5px;
  font-size: 16px;
}
.sidebar .channels .electric {
  color: yellow;
}
.sidebar .channels .thermal {
  color: orange;
}
.logo {
  height: 67px;
  width: 141px;
  margin-left: 20px;
}
.logo img {
  width: 100%;
}
.sidebar svg {
  color: #fff;
}
.arrow {
  float: right;
  cursor: pointer;
}
.side-icon {
  width: 12px;
  display: inline-block;
  margin-right: 6px;
  line-height: 10px;
  margin-top: -2px;
}
a.jump {
  cursor: pointer;
}
.menu .row {
  margin-left: 0;
  margin-right: 0;
}
.menu .row a {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 15px;
}
.sidebar .sidebar-menu li:hover .row a,
.sidebar .sidebar-menu li.active .row > a,
.sidebar .sidebar-menu li.active .row a:hover {
  color: #ffffff;
  background-color: #da7875;
}

.charts-menu .charts-tree {
  display: none;
}
.charts-menu.active .charts-tree {
  display: block;
}
.charts-menu.active .arrow-right {
  display: block;
}
.charts-menu.active.open .arrow-right {
  display: none;
}

.cus_border:after {
  position: absolute;
  height: 3px;
  width: 80px;
  background-color: #58c373;
  right: 0;
  margin: auto;
}

.border {
  border: 1px solid #908c8c;
  padding: 5px;
  background: white;
  /* margin:15px; */
}
.layout_div {
  padding: 5px;
  width: 100%;
  height: 100%;
}
.layout_div_sample {
  padding: 2px;
  width: 100%;
}
.wh-100 {
  height: 100%;
  width: 100%;
}
.main_row_style {
  background: #8080800a;
  border: 0.3px solid #8080806b;
}
.shadow {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
/* .{
  background:#8080800a;
  border: .3px solid #8080806b;
} */
.main_row_style:hover {
  box-shadow: 3px 1px 3px #aaaaaa6b;
  cursor: pointer;
}
.selected_layout {
  box-shadow: 6px 0px 10px #aaaaaa;
}
.no_report_selection {
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.report_header {
  /* display: flex;
  justify-content: flex-start;
  align-items: center; */
  padding: 10px;
  background: white;
  width: 1200px;
  position: fixed;
  z-index: 10;
  background: white;
  top: 70px;
  padding-top: 20px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #7c3437;
  background-color: #7c3437;
}
.page_no_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.report_header .btn :active {
  background-color: #cf5651 !important;
  border-color: #cf5651 !important;
}

.report_header .btn.btn-secondary {
  color: #000;
  background: #cf5651;
  border: 1px solid black;
  border-radius: 4px;
  width: 150px;
}

.chart_container {
  position: relative;
  height: 100%;
}
.chart-container-edit {
  height: auto !important;
}
.chart_container > div {
  height: 100%;
}

.chart_container section {
  height: 100%;
}
.chart_container section div {
  height: 100%;
  background-color: RED;
}
.chart_container #iqs8Ebmj {
  height: 100%;
  background-color: red;
}

.cus_row {
  margin-right: 0rem !important;
  margin-left: 0rem !important;
}
.cus_col {
  padding-right: 0.3rem !important;
  padding-left: 0.3rem !important;
}

.edit_delete_container {
  position: absolute;
  top: 3px;
  right: 5px;
  z-index: 10;
  border: 1px solid #e2e2e2;
  padding-left: 7px;
  display: flex;
  background: rgba(240, 240, 240, 0.8);
}
.overflow_content {
  overflow: hidden;
}
.half3 {
  min-height: 297px;
  height: 100%;
}
.half {
  min-height: 450px;
  height: 100%;
}
.full {
  min-height: 910px;
  height: 100%;
}
.queryWrap {
  border: 1px solid #ccc;
  background: #eee;
  width: 50%;
}
.resultWrap {
  border: 1px solid #ccc;
  background: #eee;
  flex-grow: 1;
}
.query-editor {
  border: 1px solid #ccc;
  background: #eee;
  height: 200px;
}
.variable-editor {
  border: 1px solid #ccc;
  background: #eee;
  height: 15%;
}
.codemirrorWrap {
  border: 1px solid #ccc;
  background: #eee;
  flex-grow: 1;
}
.printer-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: none;
  height: 70px;
  z-index: 1000;
  overflow: hidden;
}
.printer-img-header {
  height: 70px;
}
.fixed-50r {
  position: fixed;
  right: 50px;
}
.print_div {
  margin-bottom: 20px;
}
@media print {
  .printer-header {
    display: block;
  }
  .print_div {
    margin-bottom: 0px;
  }
  .report__page > div {
    margin-top: 0rem;
  }
}
.print_div h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/Report.vue